<fieldset>
  <legend>
    Dane pojazdu
  </legend>
  <div class="row" *ngIf="form as form" [formGroup]="form">
    <div class="col-md-4">
      <div class='form-group' *ngIf='"vehicleCategory" as controlName'>
        <label [for]='controlName'>
          Typ pojazdu *
        </label>
        <select
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [id]='controlName'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option *ngFor='let item of form.vehicleCategories' [value]='item'>
            {{ item }}
          </option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"vehicleType" as controlName'>
        <label [for]='controlName'>
          Marka pojazdu *
        </label>
        <input
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu markę pojazdu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-8'>
      <div class='form-group' *ngIf='"registrationNumberOrChassisNumber" as controlName'>
        <label [for]='controlName'>
          Numer rejestracyjny albo numer nadwozia, podwozia lub ramy *
        </label>
        <input
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu numer rejestracyjny albo numer nadwozia, podwozia lub ramy'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  </div>
</fieldset>
